import { useState, type MouseEvent } from "react";
import Tooltip from "../../../../../../components/ui/Tooltip";
import type { Device, ThemeClasses } from "../types";
import { DeviceMetaRefreshModal } from "./DeviceMetaRefreshModal";

interface DeviceCacheRefreshButtonProps {
  device: Device;
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  className?: string;
}

export function DeviceCacheRefreshButton({
  device,
  themeClasses,
  isDarkMode,
  className = "",
}: DeviceCacheRefreshButtonProps) {
  const [open, setOpen] = useState(false);

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <Tooltip content="Refrescar datos" position="top" className="!w-auto !inline-block">
        <button
          type="button"
          onClick={handleClick}
          className={`inline-flex h-7 w-7 items-center justify-center rounded-full ring-1 transition-all active:scale-95 bg-primary-500/10 text-primary-500 ring-primary-500/20 hover:bg-primary-500/20 hover:ring-primary-500/40 ${className}`}
          aria-label="Refrescar datos"
        >
          <i className="ri-refresh-line text-base leading-none" />
        </button>
      </Tooltip>
      {open && (
        <DeviceMetaRefreshModal
          device={device}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
